import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATEGORIES, TYPE_LABEL } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";

const TYPES = ["", "brief", "analysis", "research", "newsletter"];

export default function News() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState(null);
  const type = params.get("type") || "";
  const category = params.get("category") || "";
  const q = params.get("q") || "";

  useEffect(() => {
    setItems(null);
    api.get("/articles", { params: { type: type || undefined, category: category || undefined, q: q || undefined } }).then((r) => setItems(r.data));
  }, [type, category, q]);

  const update = (k, v) => { const p = new URLSearchParams(params); v ? p.set(k, v) : p.delete(k); setParams(p); };
  const title = q ? `Results for “${q}”` : category || (type ? TYPE_LABEL[type] + "s" : "Latest intelligence");

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-12 lg:py-16" data-testid="news-page">
      <p className="overline text-[#E5332A]">Archive</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold mt-3">{title}</h1>
      <div className="mt-10 flex flex-col gap-4 border-y border-[#E7E7E7] py-4">
        <div className="flex flex-wrap gap-2" data-testid="type-filters">
          {TYPES.map((t) => (
            <button key={t || "all"} data-testid={`filter-type-${t || "all"}`} onClick={() => update("type", t)}
              className={`px-4 py-1.5 text-xs font-mono-d uppercase tracking-wider border transition-colors ${type === t ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-[#E7E7E7] hover:border-[#0A0A0A]"}`}>
              {t ? TYPE_LABEL[t] : "All"}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm" data-testid="category-filters">
          <button onClick={() => update("category", "")} className={!category ? "text-[#E5332A] font-medium" : "text-[#575757] hover:text-[#0A0A0A]"}>All sectors</button>
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`filter-category-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => update("category", c)} className={category === c ? "text-[#E5332A] font-medium" : "text-[#575757] hover:text-[#0A0A0A]"}>{c}</button>
          ))}
        </div>
      </div>
      {items === null ? <p className="py-20 overline text-[#575757]">Loading…</p> : items.length === 0 ? (
        <p className="py-20 text-[#575757]" data-testid="news-empty">No stories match these filters yet.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14 mt-12" data-testid="news-grid">
          {items.map((a, i) => <ArticleCard key={a.slug} a={a} index={i} />)}
        </div>
      )}
    </div>
  );
}
